import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter, Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { formatDate, formatNumber } from '@atheneum/api/dist/lib'

class PaymentsTable extends Component {
  static propTypes = {
    payments: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  renderPayments = () => {
    const { payments, sidebarStore, staticData } = this.props

    const paymentRows = payments.map(payment => {
      let paymentUrl
      if (payment.projectId) {
        paymentUrl = `/project/${payment.projectId}/invoice/${
          payment.invoiceId
        }`
      }

      if (payment.contractId) {
        paymentUrl = `/contract/${payment.contractId}/invoice/${
          payment.invoiceId
        }`
      }

      const paymentDate = formatDate(payment.paymentDate)

      const invoicePaymentStatus =
        staticData.names.invoicePaymentStatuses[payment.invoicePaymentStatusId]

      const currency = staticData.currencies.find(
        c => c.id === payment.paymentCurrencyId
      ).name
      const netAmount = formatNumber(payment.netAmount)
      const convertedNetAmount = `${formatNumber(
        payment.convertedNetAmount
      )} EUR`
      const classes = payment.isCreditNote ? 'red-text' : ''
      const invoiceType =
        (payment.isPayg ? 'PAYG' : 'NON-PAYG') +
        (payment.isCreditNote ? ' CREDIT NOTE' : '')

      return (
        <tr key={payment.id} className={classes}>
          <td>
            <span className='text-wrapper'>{payment.id}</span>
          </td>
          <td>
            <span className='text-wrapper'>{invoicePaymentStatus}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{netAmount}</span>
          </td>
          <td>
            <span className='text-wrapper'>{currency}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {convertedNetAmount}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>{paymentDate}</span>
          </td>
          <td>
            <Link to={paymentUrl}>{payment.invoiceNumber}</Link>
          </td>
          <td>
            <span className='text-wrapper'>{invoiceType}</span>
          </td>
          <td>
            <span
              className='row--link'
              onClick={() => {
                sidebarStore.openSidebar({
                  id: payment.parentAccountId,
                  template: 'parent-account'
                })
              }}
            >
              {payment.parentAccount}
            </span>
          </td>
          <td>
            {payment.clientAccountId && (
              <span
                className='row--link'
                onClick={() => {
                  sidebarStore.openSidebar({
                    id: payment.clientAccountId,
                    template: 'client-account'
                  })
                }}
              >
                {payment.clientAccount}
              </span>
            )}
          </td>
        </tr>
      )
    })

    return <tbody>{paymentRows}</tbody>
  }

  render () {
    return (
      <table className='table-wrapper'>
        <thead>
          <tr>
            <th>Payment Id</th>
            <th>Payment status</th>
            <th className='right-align'>Net amount</th>
            <th>Currency</th>
            <th className='right-align'>Converted net amount</th>
            <th>Payment date</th>
            <th>Invoice number</th>
            <th>Invoice type</th>
            <th>Parent account</th>
            <th>Client account</th>
          </tr>
        </thead>
        {this.renderPayments()}
      </table>
    )
  }
}

export default withRouter(
  inject('sidebarStore', 'staticData')(observer(PaymentsTable))
)
